import {PropsWithChildren} from "react";

import {Card} from "@/components/card/Card.tsx";
import {Divider} from "@/components/divider/Divider.tsx";
import {SwitchField} from "@/components/form/fields/SwitchField.tsx";
import {TooltipIconRA} from "@/components/overlay/TooltipIconRA.tsx";

interface SectionGroupProps extends PropsWithChildren {
  name: string;
  label: string;
  helpText: string;
  hideErrorMessage?: boolean;
}

export const SectionGroup = ({name, label, helpText, children, hideErrorMessage = false}: SectionGroupProps) => {
  return (
    <Card variant="white" className="p-0">
      <div className="p-3">
        <div className="d-flex align-items-center">
          <label htmlFor={name} className="pulseTextBodyBold pulse-color-gray-800">
            {label}
          </label>
          <TooltipIconRA className="ms-1" title={helpText} />
          <SwitchField className="ms-auto" name={name} hideErrorMessage={hideErrorMessage} />
        </div>
      </div>
      <Divider />
      <div className="p-3 pulse-color-gray-900 d-flex flex-column gap-2">{children}</div>
    </Card>
  );
};
